goog.provide("shadow.js.shim.module$$mui$material$ToggleButton$default");
shadow.js.shim.module$$mui$material$ToggleButton$default = shadow.js.shim.module$$mui$material$ToggleButton.default;
